import React from 'react';
import {
  Disclaimer,
  Footer,
  useGetAppInitDetails,
  useMobileAppDownloadLinks,
  useMemberBrandingInfo,
  EnhancedMembersDisclaimer,
} from '@highmark-web/highmark-common';
import { Image } from '@leagueplatform/genesis-commons';
import { useFooterLinks } from 'hooks/use-footer-links';
import { APP_STORE_PROD_URL, PLAY_STORE_PROD_URL } from 'common/constants';
import { SkeletonBox } from '@leagueplatform/web-common-components';

export const AllMyHealthFooter = React.memo(() => {
  const { footerLinks } = useFooterLinks();
  const { mobileAppDownloadLinks } = useMobileAppDownloadLinks(
    APP_STORE_PROD_URL,
    PLAY_STORE_PROD_URL,
  );
  const { isLoading, appMessaging } = useGetAppInitDetails();
  const { brandingInfo, shouldUseEnhancedMemberBranding } =
    useMemberBrandingInfo();

  if (isLoading)
    return (
      <SkeletonBox
        borderRadius="none"
        height="200px"
        backgroundColor="surface.background.secondary"
      />
    );

  const brandingLogoAlt = (() => {
    if (shouldUseEnhancedMemberBranding) {
      if (brandingInfo?.brandingName) {
        return `${brandingInfo?.brandingName} Branding`;
      }
      return 'Provider Branding';
    }
    return 'AllMyHealth Branding';
  })();

  // For enhanced members the branding and disclaimer are expected to be different.
  const branding = (
    <Image
      src={brandingInfo?.brandingLogo}
      alt={brandingLogoAlt}
      tabIndex={0}
      maxWidth={shouldUseEnhancedMemberBranding ? '170px' : undefined}
      width={shouldUseEnhancedMemberBranding ? 'unset' : '170px'}
    />
  );
  const disclaimer = shouldUseEnhancedMemberBranding ? (
    <EnhancedMembersDisclaimer />
  ) : (
    <Disclaimer hasLegalModal disclaimer={appMessaging?.disclaimer} />
  );
  return (
    <Footer
      branding={branding}
      disclaimer={disclaimer}
      footerAppDownloadAssets={
        shouldUseEnhancedMemberBranding ? undefined : mobileAppDownloadLinks
      }
      footerLinks={shouldUseEnhancedMemberBranding ? undefined : footerLinks}
    />
  );
});
